// src/pages/B2B/event-reports/pdf/ReportPdfDocument.tsx
//
// Dispatcher that picks a PDF generator based on report_type.
// Today only 'report_for_businesses' is wired up (warm marketing flier via
// html2pdf).

import type { EventReportPayload } from '../types';
import { buildWarmPdfBlob } from './warm/buildWarmPdf';

export interface BuildPdfInput {
  reportType: 'report_for_businesses';
  payload: EventReportPayload;
  eventName: string;
  fromLocal: string;
  toLocal: string;
  timezone: string;
  locationLabel: string;
  imageDataUrl: string | null;
}

export async function buildPdfBlob(input: BuildPdfInput): Promise<Blob> {
  switch (input.reportType) {
    case 'report_for_businesses':
      return buildWarmPdfBlob(input);
    default: {
      const exhaustiveCheck: never = input.reportType;
      throw new Error(`Unsupported report_type: ${String(exhaustiveCheck)}`);
    }
  }
}
